class AnimateElement {
    _observer = null;

    _animatedElements = new Set();

    /* Private methods
    ******************** */
    _initScrollAnimations = () => {
        if (!document.querySelector('[data-animate]')) {
            return;
        }

        const options = {
            root: null,
            rootMargin: '0px 0px -100px 0px', // Trigger animation 100px before element enters viewport
            threshold: 0.15 // Trigger when 15% of element is visible
        };

        this._observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                }
            });
        }, options);

        document.querySelectorAll('[data-animate]').forEach((element) => {
            this._animatedElements.add(element);

            this._observer.observe(element);
        });
    };

    /* Public methods
    ******************** */
    initialize = () => {
        // Wait for DOM to be ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this._initScrollAnimations();
            });
        } else {
            this._initScrollAnimations();
        }
    };

    destroy = () => {
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }

        this._animatedElements.clear();
    };
}

export default new AnimateElement();
